<template>
	<div>
		<button @click='openLegend' class='custom-load-input'>Условные обозначения</button>

		<custom-p-modal
			v-model.sync='modalIsOpen'
			title='Условные обозначения'

		>
			<LegendContent/>
		</custom-p-modal>

  <div class="abris-border-title">
    Укажите границы участка
  </div>
		</div>
</template>

<script>
	import LegendContent from './ActGeometry__legendContent';

	export default {
		name: 'LegendBlock',

		components: {
			LegendContent
		},

		data: () => ({
			modalIsOpen: false,
		}),

		methods: {
			openLegend() {
				this.modalIsOpen = true;
			},

			onModalToggle(event) {
				this.$emit('toggle', event);
			}
		}
	};
</script>

<style scoped>
.abris-border-title {
	font-size: 16px;
    font-style: italic;
    font-weight: bold;
    margin-bottom: 10px;
}
.custom-load-input {
		border: none;
		border-radius: 5px;
		display: inline-block;
		padding: 4px 14px;
		background-color: black;
		color: white;
		cursor: pointer;
		margin: 10px 0 20px 0;
	}
</style>